var map = {
	"./arrow_right.svg": 1156,
	"./bag.svg": 1158,
	"./caret_down.svg": 1159,
	"./chevron_down.svg": 1160,
	"./chevron_down_small.svg": 1161,
	"./chevron_left.svg": 1162,
	"./chevron_right.svg": 1163,
	"./chevron_up.svg": 1164,
	"./chevron_up_small.svg": 1165,
	"./close.svg": 1166,
	"./heart.svg": 1167,
	"./info-filled.svg": 1168,
	"./search-no-results.svg": 1169,
	"./search.svg": 1170,
	"./social-logo/apple.svg": 1171,
	"./social-logo/facebook.svg": 1172,
	"./social-logo/google.svg": 1173,
	"./stone-shape/asscher.svg": 1174,
	"./stone-shape/baguette.svg": 1175,
	"./stone-shape/cushion.svg": 1176,
	"./stone-shape/emerald.svg": 1177,
	"./stone-shape/heart.svg": 1178,
	"./stone-shape/marquise.svg": 1179,
	"./stone-shape/oval.svg": 1180,
	"./stone-shape/pear.svg": 1181,
	"./stone-shape/princess.svg": 1182,
	"./stone-shape/radiant.svg": 1183,
	"./stone-shape/round.svg": 1184,
	"./stone-shape/tapered-baguette.svg": 1185,
	"./stone-shape/triangle.svg": 1186,
	"./stone-shape/trillion.svg": 1187,
	"./tag.svg": 1188,
	"./truck.svg": 1189,
	"./user.svg": 1190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1155;